import { FilterChipOption } from './CustomOption';
import { StylesConfig, GroupBase } from 'react-select';

export const getDisplayText = <T = string>(selectedOptions: FilterChipOption<T>[], isMulti: boolean) => {
  if (!selectedOptions.length) return '';
  if (!isMulti || selectedOptions.length === 1) return selectedOptions[0].label;
  return `${selectedOptions.length} Selected`;
};

export const createFilterChipStyles = <
  T = string,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<FilterChipOption<T>> = GroupBase<FilterChipOption<T>>,
>(
  hideInput: boolean
): StylesConfig<FilterChipOption<T>, IsMulti, Group> => ({
  menu: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
    border: 'none',
    boxShadow: 'none',
    backgroundColor: 'transparent',
    position: 'relative',
  }),
  option: (base) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
  }),
  control: (base) => ({
    ...base,
    display: hideInput ? 'hidden' : base.display,
    margin: hideInput ? 0 : '8px 12px',
    border: hideInput ? 'none' : `1px solid #E5E5E5`,
    opacity: hideInput ? 0 : 1,
    height: hideInput ? 0 : base.height,
    borderRadius: 4,
    background: 'white',
  }),
  menuList: (base) => ({
    ...base,
    padding: 0,
  }),
  input: (base) => ({
    ...base,
    padding: 8,
    display: hideInput ? 'hidden' : base.display,
  }),
});
